import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useCurrentPage from "../../../../hooks/useCurrentPage";
import axios from "axios";
import MainServices from "../../../../services/MainServices";
import moment from "moment";
import PageLoader from "../../../../assets/loaders/PageLoading";
import ApprovalStatusModal from "../../../../assets/modal/ApprovalStatusModal";
import { notifySuccess, notifyWarn } from "../../../../assets/elements/Toast";
import { Button, Modal } from "react-bootstrap";
import { Table } from "reactstrap";
import "./FormatNumberDetails.scss";
import PermissionFunctions from "../../../../assets/functions/PermissionFunctions";
import editicon from "../../../../assets/images/icons/edit.svg";
import { InputGroup, Form } from "react-bootstrap";
import { PrimaryInput } from "../../../../assets/FormElements";
import { Formik } from "formik";
import useAuth from "../../../../hooks/useAuth";
import useFeatureSetting from "../../../../hooks/useFeatureSetting";
import * as Yup from "yup";
import CustomErrorMessage from "../../../../assets/elements/ErrorMessage";
import { squareBackIcon, backarrowicon } from "../../../../assets/images/icons/icons";
import { PrimaryButton } from "../../../../assets/buttons";
import ButtonLoading from "../../../../assets/loaders/ButtonLoading";
import Cross from "../../../../assets/images/icons/cross.svg";
import IsWorkflowSlug from "../../../../assets/modal/IsWorkflowSlug";
import CustomDigitalSignature from "../../../../assets/modal/CustomDigitalSignature";
import Workflows from "../../../../assets/workflows/Workflows";
import WorkflowHistory from "../../../../assets/workflows/WorkflowHistory";

const FormatNumberDetails = () => {
    const { updateCurrentPage } = useCurrentPage();
    const {
        getFormatNumbersById,
        updateEventWorkflowReview,
        getEventWorkflowById,
        getWorkFlowsByType,
        getWorkFlowHistoryByType,
        updateFormatNumbers,
        getWorkflowsBySlug,
        getPlants,
    } = MainServices();

    const [pageLoading, setPageLoading] = useState(0);
    const [formatNumber, setFormatNumber] = useState({});
    const [workflowMasters, setWorkflowMasters] = useState({});
    const location = useLocation();
    const [approvedLoading, setApprovedLoading] = useState(0);
    const [approvedModal, setApprovedModal] = useState(false);
    const [sopWorkFlows, setSopWorkFlows] = useState([]);
    const [workFlowHisories, setWorkFlowHisories] = useState([]);
    const { user } = useAuth();
    const [buttonLoading, setButtonLoading] = useState(0);
    const { grantPermission } = PermissionFunctions();
    const { updateSettingContext, setting } = useFeatureSetting();
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 20,
    });

    const edit = new URLSearchParams(location.search).get("edit");
    const [editInitiated, setEditInitiated] = useState(false);
    const [workflowAssign, setWorkflowAssign] = useState({});
    const [intiLoading, setIntiLoading] = useState(0);
    const [addFormatNumberModal, setAddFormatNumberModal] = useState(false);
    const [selectedFormatNumber, setSelectedFormatNumber] = useState({});
    const [isWorkflowFlag, setIsWorkflowFlag] = useState({});
    const [workflowDataSet, setWorkflowDataSet] = useState("");
    const [reinitiateClicked, setReinitiateClicked] = useState(false);
    const [workflowModal, setWorkflowModal] = useState(false);
    const [digitalSignatureModal, setDigitalSignatureModal] = useState(false);
    const [isStatusUpdate, setIsStatusUpdate] = useState(0);
    const [defaultPlantName, setDefaultPlantName] = useState("");

    const publicId = new URLSearchParams(location.search).get("publicId");
    const refId = new URLSearchParams(location.search).get("refId");
    const workflowConcurrencystamp = new URLSearchParams(location.search).get(
        "workflowConcurrencystamp"
    );
    const navigate = useNavigate();

    useEffect(() => {
        updateCurrentPage({
            title: "Format Number",
            subtitle: "Details",
        });
    }, []);

    useEffect(() => {
        updateSettingContext("format_numbers");
    }, []);

    useEffect(() => {
        if (publicId) {
            getFormatNumberById();
            getSopWorkflows();
            getWorkflowHistory();
            getIsWorkflowSlug();
        }
    }, [publicId]);

    useEffect(() => {
        if (refId) {
            getWorkflowById();
        }
    }, [refId]);

    useEffect(() => {
        if (edit === "true" && !editInitiated && formatNumber?.publicId) {
            onAddFormatNumber(formatNumber);
            setEditInitiated(true);
        }
    }, [edit, editInitiated, formatNumber]);

    const formatNumberSchema = Yup.object().shape({
        name: Yup.string()
            .transform((value) => value.trim())
            .required("Name is Required"),
        formatNo: Yup.string()
            .transform((value) => value.trim())
            .required("Format Number is Required"),
        type: Yup.string()
            .transform((value) => value.trim())
            .required("Type is Required"),
        subType: Yup.string()
            .transform((value) => value.trim())
            .required("Sub Type is Required"),
    });

    const updateFormatNumberSchema = Yup.object().shape({
        name: Yup.string()
            .transform((value) => value.trim())
            .required("Name is Required"),
        formatNo: Yup.string()
            .transform((value) => value.trim())
            .required("Format Number is Required"),
        type: Yup.string()
            .transform((value) => value.trim())
            .required("Type is Required"),
        subType: Yup.string()
            .transform((value) => value.trim())
            .required("Sub Type is Required"),
        workflows: Yup.array()
            .of(
                Yup.object().shape({
                    users: Yup.array().required("users array is required"),
                })
            )
            .test("at-least-one-user", "Workflow is Required", function (workflows) {
                return workflows.some(
                    (workflow) => workflow.users && workflow.users.length > 0
                );
            }),
    });

    const getFormatNumberById = async () => {
        setPageLoading(true);
        const details = {};

        await axios
            .all([getFormatNumbersById(details, publicId)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let formatNumberData = resData.data ? resData.data : {};
                        setFormatNumber(formatNumberData);
                        setPageLoading(false);
                    } else {
                        setPageLoading(false);
                    }
                } else {
                    setPageLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting Format Number details");
            });
    };

    const getWorkflowById = async () => {
        setPageLoading(true);
        const details = {
            filters: [{ key: "publicId", eq: refId }],
        };

        await axios
            .all([getEventWorkflowById(details)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let workflows = resData.data ? resData.data : [];
                        setWorkflowMasters(workflows[0]);
                        setPageLoading(false);
                    } else {
                        setPageLoading(false);
                    }
                } else {
                    setPageLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting Event Workflow");
            });
    };

    const updateFormatNumber = async (values) => {
        setButtonLoading(true);
        let workflowInfo = values?.workflows || [];
        let workflowFlag = false;

        workflowInfo =
            workflowInfo.length > 0
                ? workflowInfo.map((each) => ({
                    ...each,
                    users: each?.users?.map((user) => {
                        workflowFlag = true;
                        return {
                            value: user?.publicId,
                        };
                    }),
                    ...(each?.no_of_approvals
                        ? { no_of_approvals: each?.no_of_approvals }
                        : {
                            no_of_approvals: each?.users && each?.users.length,
                        }),
                }))
                : [];

        const details = {
            name: values.name,
            formatNo: values.formatNo,
            type: values.type,
            subType: values.subType,
            plantId: user?.selectedPlant || formatNumber?.plantId,
            ...(values?.remark && { remark: values?.remark }),
            ...(values?.password && { password: values?.password }),
        };

        if (workflowFlag) {
            details.workflowInfo = workflowInfo;
        }

        await axios
            .all([
                updateFormatNumbers(
                    details,
                    selectedFormatNumber.publicId,
                    selectedFormatNumber.concurrencyStamp
                ),
            ])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData?.message;
                    if (resData.success) {
                        getFormatNumberById();
                        onAddFormatNumber(false);
                        setDigitalSignatureModal(false);
                        values?.status === "approved" && navigate(-1);
                        notifySuccess("Format Number Updated Successfully");
                        setButtonLoading(false);
                    } else {
                        message && notifyWarn(message);
                        setButtonLoading(false);
                    }
                } else {
                    setButtonLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in updating Format Number");
            });
    };

    const updateWorkflowStatus = async (values) => {
        setApprovedLoading(true);
        const details = {
            workflowStatus: values.status?.value,
            ...(values?.password && { password: values.password }),
            comments: values.comment,
        };

        await axios
            .all([
                updateEventWorkflowReview(details, refId, workflowConcurrencystamp),
            ])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData?.message;
                    if (resData.success) {
                        notifySuccess("Status changed successfully");
                        setIsStatusUpdate(Math.random());
                        setApprovedLoading(false);
                        onApprovedStatusModal();
                        getFormatNumberById();
                        getWorkflowById();
                        getSopWorkflows();
                        getWorkflowHistory();
                    } else {
                        message && notifyWarn(message);
                        setApprovedLoading(false);
                    }
                } else {
                    setApprovedLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in status update");
            });
    };

    const getSopWorkflows = async () => {
        const details = {
            workFlowType: "format_numbers",
            sorting: [{ key: "id", direction: "asc" }],
        };

        await axios
            .all([getWorkFlowsByType(details, publicId)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let workflows = resData.data ? resData.data : {};
                        setWorkflowAssign(workflows);
                        workflows = workflows.eventWorkflows
                            ? workflows.eventWorkflows
                            : [];
                        setSopWorkFlows(workflows);
                    } else {
                    }
                } else {
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting workflows");
            });
    };

    const getWorkflowHistory = async () => {
        const details = {
            sorting: [{ key: "id", direction: "desc" }],
        };

        await axios
            .all([getWorkFlowHistoryByType(details, publicId)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let workflowHistory = resData.data ? resData.data : [];
                        setWorkFlowHisories(workflowHistory);
                    } else {
                    }
                } else {
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting workflows");
            });
    };

    const updateFormatNumberIntiatad = async (values) => {
        setButtonLoading(true);
        const details = {
            name: values.name,
            formatNo: values.formatNo,
            type: values.type,
            subType: values.subType,
            plantId: user?.selectedPlant || formatNumber?.plantId,
            ...(values?.password && { password: values?.password }),
            reinitiateWorkflowAssignId: workflowAssign.publicId,
            status: "reinitiated",
        };

        await axios
            .all([
                updateFormatNumbers(
                    details,
                    selectedFormatNumber.publicId,
                    selectedFormatNumber.concurrencyStamp
                ),
            ])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData?.message;
                    if (resData.success) {
                        getFormatNumberById();
                        onAddFormatNumber();
                        setReinitiateClicked(false);
                        setDigitalSignatureModal(false);
                        setIsStatusUpdate(Math.random());
                        notifySuccess("Format Number Updated Successfully");
                        setButtonLoading(false);
                    } else {
                        message && notifyWarn(message);
                        setButtonLoading(false);
                    }
                } else {
                    setButtonLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in updating Format Number");
            });
    };

    const getIsWorkflowSlug = async () => {
        const details = {};
        await axios
            .all([getWorkflowsBySlug(details)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let isWorkflow = resData?.data ? resData?.data : {};
                        isWorkflow = isWorkflow?.content
                            ? JSON.parse(isWorkflow?.content)
                            : {};
                        setIsWorkflowFlag(isWorkflow);
                    } else {
                    }
                } else {
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting workflow");
            });
    };

    const getPlantMasters = async (filters) => {
        const details = {
            filters,
        };

        let results = await getPlants(details)
            .then((res) => {
                if (res) {
                    let resData = res;
                    if (resData.success) {
                        resData = resData.data ? resData.data : [];

                        const plantName = resData?.[0]?.plantName || "";
                        const plantData = resData?.[0] || null;

                        setDefaultPlantName(plantName);
                        return resData;
                    }
                }
            })
            .catch(function (res) {
                console.error("Error in getPlants:", res);
            });
        return results;
    };

    const handleWorkflowAssignUpdate = (updatedWorkflowAssign) => {
        setWorkflowAssign(updatedWorkflowAssign);
    };

    const onManageWorkflow = ({ values, setFieldValue }) => {
        setWorkflowDataSet({
            workflows: values?.workflows,
            setFieldValue,
        });
        setWorkflowModal((prev) => !prev);
    };

    const onApprovedStatusModal = () => {
        setApprovedModal(!approvedModal);
    };

    const onAddFormatNumber = (selected) => {
        if (selected) {
            setSelectedFormatNumber(selected);
        } else {
            setSelectedFormatNumber("");
        }
        setAddFormatNumberModal(!addFormatNumberModal);
    };

    const onDigitalSignatureModal = () => {
        setDigitalSignatureModal(!digitalSignatureModal);
    };

    useEffect(() => {
        if (formatNumber?.plantId) {
            getPlantMasters([
                {
                    key: "publicId",
                    eq: formatNumber?.plantId,
                }
            ]);
        }
    }, [formatNumber?.plantId]);

    return (
        <div className="training-sop-main">
            <div className="admin-popular-main lims-details-page tms-inventory-details-page">
                <div className="details-page-toolbar">
                    <div className="details-page-toolbar__left">
                        <button
                            type="button"
                            className="btn btn-link details-page-back-btn"
                            onClick={() => navigate(-1)}
                            title="Back"
                            aria-label="Go back"
                        >
                            {backarrowicon}
                        </button>
                        <div className="details-page-title-block">
                            <p className="content-header-main mb-0">Format Number Details</p>
                        </div>
                    </div>
                    <div className="details-page-toolbar__right">
                        {grantPermission("FormatNumbers_update") &&
                            (formatNumber?.status === "approved" ||
                                formatNumber?.status === "rejected") &&
                            formatNumber?.recordStatus === "active" && (
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => onAddFormatNumber(formatNumber)}
                                >
                                    <img src={editicon} alt="Edit icon" />
                                </div>
                            )}
                        {refId && workflowMasters?.workflowStatus === "pending" && (
                            <Button className="details-page-action-btn theme-btn-main" onClick={onApprovedStatusModal}>Update Status</Button>
                        )}
                    </div>
                </div>
                {pageLoading ? (
                    <PageLoader />
                ) : formatNumber ? (
                    <div className="details-page-content">
                        <div className="details-card">
                            <div className="details-card__header">
                                <h3 className="details-card__title">Overview</h3>
                            </div>
                            <div className="details-grid">
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Name</div>
                                    <div className="details-grid__value">{formatNumber.name}</div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Format Number</div>
                                    <div className="details-grid__value">{formatNumber?.formatNo}</div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Type</div>
                                    <div className="details-grid__value">{formatNumber?.type}</div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Sub Type</div>
                                    <div className="details-grid__value">{formatNumber?.subType}</div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Plant</div>
                                    <div className="details-grid__value">
                                        {defaultPlantName || formatNumber?.fnPlant?.plantName || formatNumber?.plant?.plantName || formatNumber?.plantId || "N/A"}
                                    </div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Created At</div>
                                    <div className="details-grid__value">{moment(formatNumber?.createdAt).format("DD-MM-YYYY")}</div>
                                </div>
                                <div className="details-grid__item">
                                    <div className="details-grid__label">Status</div>
                                    <div className="details-grid__value">{formatNumber?.status}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="no-data-found-main">No Format Number Found</div>
                )}

                <Workflows
                    publicId={publicId}
                    isStatusUpdate={isStatusUpdate}
                    onWorkflowAssignUpdate={handleWorkflowAssignUpdate}
                    initiator={formatNumber?.createdBy?.empName}
                    workFlowType="format_numbers"
                />

                <WorkflowHistory
                    publicId={publicId}
                    isStatusUpdate={isStatusUpdate}
                    workFlowType="format_numbers"
                />
            </div>
            <Modal
                centered
                show={addFormatNumberModal}
                onHide={onAddFormatNumber}
                className="add-department-modal-main"
                selected={selectedFormatNumber}
                size="lg"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        {selectedFormatNumber && selectedFormatNumber?.publicId
                            ? "Update"
                            : "Add"}{" "}
                        Format Number
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="add-department-modal-body">
                    <p className="mb-4 add-department-modal-content-text">
                        Please Enter Format Number Details
                    </p>
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            name: selectedFormatNumber?.name || "",
                            formatNo: selectedFormatNumber?.formatNo || "",
                            type: selectedFormatNumber?.type || "",
                            plant: defaultPlantName || "",
                            subType: selectedFormatNumber?.subType || "",
                            workflow_name: selectedFormatNumber?.name || "",
                            workflows: selectedFormatNumber?.workflowData || [
                                {
                                    workflow: "reviewer",
                                    users: [],
                                    no_of_approvals: "",
                                },
                                {
                                    workflow: "approver",
                                    users: [],
                                    no_of_approvals: "",
                                },
                            ],
                            disabled:
                                selectedFormatNumber?.disabled === false ||
                                    selectedFormatNumber?.disabled === "No"
                                    ? true
                                    : false,
                        }}
                        validationSchema={
                            setting?.workflow_required === "true"
                                ? updateFormatNumberSchema
                                : formatNumberSchema
                        }
                        onSubmit={(values) => {
                            if (setting.digital_signature) {
                                setSelectedFormatNumber({ ...selectedFormatNumber, ...values });
                                onDigitalSignatureModal();
                            } else {
                                updateFormatNumber(values);
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            dirty,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <Form className="form" onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Name
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                        name="name"
                                        id="name"
                                    />
                                    <CustomErrorMessage
                                        name="name"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>

                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Format Number
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Format Number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.formatNo}
                                        name="formatNo"
                                        id="formatNo"
                                    />
                                    <CustomErrorMessage
                                        name="formatNo"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Type
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Type"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type}
                                        name="type"
                                        id="type"
                                    />
                                    <CustomErrorMessage
                                        name="type"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="plant">
                                        Plant
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="plant"
                                        name="plant"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.plant || ""}
                                        disabled
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Sub Type
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Sub Type"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.subType}
                                        name="subType"
                                        id="subType"
                                    />
                                    <CustomErrorMessage
                                        name="subType"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>

                                {setting?.workflow_disabled === "false" &&
                                    selectedFormatNumber?.status === "approved" && (
                                        <>
                                            <div
                                                className="my-4"
                                                style={{ borderBottom: "1px dashed #000" }}
                                            />
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className="mb-0" style={{ fontWeight: 500 }}>
                                                    Manage Workflow :
                                                    {setting?.workflow_required === "true" && (
                                                        <span style={{ color: "#f00" }}> *</span>
                                                    )}
                                                </p>
                                                <Button
                                                    className="theme-btn-main"
                                                    style={{ padding: "11px 12px" }}
                                                    onClick={() =>
                                                        onManageWorkflow({
                                                            values,
                                                            setFieldValue,
                                                        })
                                                    }
                                                >
                                                    Manage Workflow
                                                </Button>
                                            </div>
                                            <div className="workflows-list">
                                                {values.workflows &&
                                                    values.workflows.length > 0 &&
                                                    values.workflows.map((each_work, index) => {
                                                        const options = Array.from(
                                                            {
                                                                length:
                                                                    each_work?.users &&
                                                                    each_work?.users.length > 0 &&
                                                                    each_work?.users.length,
                                                            },
                                                            (_, i) => ({
                                                                label: `${i + 1}`,
                                                                value: i + 1,
                                                            })
                                                        );

                                                        return (
                                                            <div className="each-work-flow mt-3" key={index}>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="workflow-head">
                                                                        <span
                                                                            style={{
                                                                                textTransform: "capitalize",
                                                                            }}
                                                                        >
                                                                            {each_work.workflow}
                                                                        </span>
                                                                    </div>
                                                                    <div className="form-group mb-1 d-flex gap-2 align-items-center">
                                                                        <label
                                                                            className="form-label mb-0"
                                                                            htmlFor="category"
                                                                        >
                                                                            {`Select Number of ${each_work.workflow}`}
                                                                            <span style={{ color: "#f00" }}> *</span>
                                                                        </label>
                                                                        <div className="form-control-wrap">
                                                                            <select
                                                                                className="sop-custom-form-select"
                                                                                id={`workflows.${index}.no_of_approvals`}
                                                                                name={`workflows.${index}.no_of_approvals`}
                                                                                placeholder="Select"
                                                                                onChange={(option) => {
                                                                                    setFieldValue(
                                                                                        `workflows.${index}.no_of_approvals`,
                                                                                        option?.target.value
                                                                                    );
                                                                                }}
                                                                                onBlur={handleBlur}
                                                                                style={{
                                                                                    width: "100px",
                                                                                    fontSize: "12px",
                                                                                    padding: "6px",
                                                                                }}
                                                                            >
                                                                                <option>Select...</option>
                                                                                {options &&
                                                                                    options?.length > 0 &&
                                                                                    options.map((option) => {
                                                                                        return (
                                                                                            <option value={option.value}>
                                                                                                {option.label}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                            <CustomErrorMessage
                                                                                name={`noOfApprovals_${index}`}
                                                                                errors={errors}
                                                                                touched={touched}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="users mt-2 px-3">
                                                                    {each_work.users &&
                                                                        each_work.users.length > 0 &&
                                                                        each_work.users.map((user, subI) => (
                                                                            <div
                                                                                className="each-user d-flex justify-content-between mt-2"
                                                                                key={subI}
                                                                            >
                                                                                <div>
                                                                                    <span>{subI + 1}.</span>
                                                                                    <span
                                                                                        style={{
                                                                                            textTransform: "capitalize",
                                                                                        }}
                                                                                    >
                                                                                        {user.label}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <img
                                                                                        alt="Cross"
                                                                                        src={Cross}
                                                                                        className="delete-topic"
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            let data =
                                                                                                values?.workflows || [];
                                                                                            let users =
                                                                                                data[index].users || [];
                                                                                            users = users.filter(
                                                                                                (each, i) => subI !== i
                                                                                            );
                                                                                            data[index].users = users;
                                                                                            setFieldValue("workflows", data);
                                                                                            setFieldValue(
                                                                                                `workflows.${index}.no_of_approvals`,
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </>
                                    )}

                                {!digitalSignatureModal && (
                                    <div className="mt-3">
                                        <div className="d-flex gap-2">
                                            <Button
                                                className="back-icon-btn-main"
                                                onClick={onAddFormatNumber}
                                            >
                                                <span>{squareBackIcon}</span>
                                                <span className="ms-2">Back</span>
                                            </Button>
                                            <PrimaryButton
                                                className="theme-btn-main"
                                                type="submit"
                                                disabled={!dirty}
                                                title={buttonLoading ? <ButtonLoading /> : "Submit"}
                                            />
                                            {selectedFormatNumber?.status === "rejected" && (
                                                <Button
                                                    className="theme-btn-main"
                                                    onClick={() => {
                                                        if (setting.digital_signature) {
                                                            setSelectedFormatNumber((prev) => ({
                                                                ...prev,
                                                                ...values,
                                                            }));
                                                            onDigitalSignatureModal();
                                                            setReinitiateClicked(true);
                                                        } else {
                                                            updateFormatNumberIntiatad(values);
                                                        }
                                                    }}
                                                    disabled={!dirty}
                                                >
                                                    {intiLoading ? (
                                                        <ButtonLoading />
                                                    ) : selectedFormatNumber ? (
                                                        "Submit & Reinitiate"
                                                    ) : (
                                                        ""
                                                    )}
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal
                centered
                show={approvedModal}
                onHide={onApprovedStatusModal}
                className="add-department-modal-main"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        Update Status
                    </Modal.Title>
                </Modal.Header>

                {approvedModal && (
                    <Modal.Body className="add-department-modal-body">
                        <ApprovalStatusModal
                            statusApiFunction={updateWorkflowStatus}
                            onClose={onApprovedStatusModal}
                            loading={approvedLoading}
                        />
                    </Modal.Body>
                )}
            </Modal>

            <Modal
                centered
                show={workflowModal}
                onHide={() => onManageWorkflow({})}
                className="add-department-modal-main"
                size="xl"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        Manage Workflow
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="add-department-modal-body">
                    <IsWorkflowSlug
                        onManageWorkflow={() => onManageWorkflow({})}
                        workflowDataSet={workflowDataSet}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                centered
                show={digitalSignatureModal}
                onHide={onDigitalSignatureModal}
                className="add-department-modal-main"
                size="md"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        E - Signature
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="add-department-modal-body">
                    <CustomDigitalSignature
                        digitalSignatureHandleSubmit={
                            reinitiateClicked ? updateFormatNumberIntiatad : updateFormatNumber
                        }
                        onDigitalSignatureModal={onDigitalSignatureModal}
                        values={selectedFormatNumber}
                        isLoading={reinitiateClicked ? intiLoading : buttonLoading}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default FormatNumberDetails;